module.exports = __webpack_public_path__ + "img/middleleft3.4382d7e0.png";